import { MoveStatus } from '../models';

const MoveStatuses = [
    MoveStatus.TODO,
    MoveStatus.IN_PROGRESS,
    MoveStatus.ACHIEVED
];

export const getMoveStatuses = () => MoveStatuses;
